module.exports = __webpack_public_path__ + "static/media/gps.436b7cb6.svg";